var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUpwardArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.5 7.475 1.134 1.018 5.87-5.26L14.366 8.5l.547-.491.587-.526L9.067 1.71a.87.87 0 0 0-1.134 0L1.5 7.475z",
    fill: "#A1AEB7",
    fillRule: "nonzero"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUpwardArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upwardArrow.41f3d51f.svg";
export { ForwardRef as ReactComponent };